import React, { useContext } from "react";
import { Cell } from "src/components/Table/Cell";
import TableCell from "src/components/Table/TableCell";
import TableRow from "src/components/Table/TableRow";
import { colors } from "src/styles";
import { Ticket } from "src/types";
import { useSelector } from "react-redux";
import { getUserData } from "src/redux/selectors/user";
import { getPriorityLevels } from "src/redux/selectors/workRequest";
import { getAllActiveResources } from "src/redux/selectors/resources";
import { TablePriorityBadge, TableStatusDot, TableStatusInline } from "../styles";
import { getResourseData } from "src/components/molecules/WorkRequestListViewContainer/handler";
import WorkRequestListContext from "src/pages/WorkRequests/context";
import { useNavigate } from "react-router-dom";

const VendorTableRow = ({ ticket }: { ticket: Ticket }) => {
  const navigate = useNavigate();
  const { searchText } = useContext(WorkRequestListContext);

  const { clientId } = useSelector(getUserData);
  const { employees, vendors } = useSelector(getAllActiveResources);
  const priorityLevels = useSelector(getPriorityLevels);

  const pickedPriorityLevel = priorityLevels?.[ticket.clientId ?? clientId]?.find(
    ({ priority }) => priority === ticket.priorityId,
  );
  const assignee = getResourseData(ticket.vendorId, ticket.laborId, vendors, employees) ?? "Unassigned";
  const statusRaw = ticket.statusDescription ?? ticket.status ?? "";
  const statusLabel = statusRaw.replace(/_/g, " ");
  const isNewStatus = statusRaw.trim().toLowerCase() === "new";
  const displayWonum = ticket.displayWonum || ticket.wonum;

  const splittedDate = ticket.dateCreated.split(", ");
  const onRowClick = (wonum: string) => {
    navigate(`/workrequests/${wonum}`, { state: { ticketNumber: wonum } });
  };

  return (
    <TableRow
      onClick={() => {
        onRowClick && onRowClick(ticket.wonum);
      }}
      $appearance="legacy"
      $clickable={true}
      key={ticket.wonum}
    >
      <Cell appearance="legacy" showMark highlight={searchText ?? ""}>
        {displayWonum}
      </Cell>
      <Cell appearance="legacy" highlight={searchText ?? ""} bold={splittedDate[0] ?? ""}>
        {(searchText ?? ""?.trim().length) ? ticket.dateCreated : `, ${splittedDate[1] ?? ""}`}
      </Cell>

      <Cell appearance="legacy" showMark highlight={searchText ?? ""}>
        {ticket.client ?? ""}
      </Cell>

      <Cell appearance="legacy" showMark highlight={searchText ?? ""}>
        {ticket.location}
      </Cell>
      <Cell appearance="legacy" showMark highlight={searchText ?? ""}>
        {ticket.description ?? ""}
      </Cell>

      <TableCell $appearance="legacy">
        <TablePriorityBadge color={pickedPriorityLevel ? pickedPriorityLevel.color : colors.grey.default}>
          {ticket.priority}
        </TablePriorityBadge>
      </TableCell>
      <TableCell $appearance="legacy">
        <TableStatusInline>
          <TableStatusDot $isNew={isNewStatus} />
          {statusLabel}
        </TableStatusInline>
      </TableCell>
      <Cell appearance="legacy" showMark highlight={searchText ?? ""}>
        {assignee}
      </Cell>
    </TableRow>
  );
};

export default VendorTableRow;
